<template>
    <div id="findpass2">
        <Header />
        <div class="findpass2_box">
            <h1>비밀번호 찾기</h1>
            <p>비밀번호 재설정 메일을 보냈습니다.<br>메일함을 확인해 보세요.</p>
            <p>메일이 수신되지 않는 경우에는 스팸 메일함<br>을 확인해보시기 바랍니다.</p>
            <router-link tag="a" to="/" class="home">아튜브 홈으로</router-link>
            <div class="ps">※ 이용 중 도움이 필요하시면 [고객지원] 페이지로, 로그인에 문제가 있다면 <a href="mailto:contact@artube.video">contact@artube.video</a>으로 문의해주세요.</div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'FindPass',
        pageCategory: '',
        components: {
            Header,
            Footer,
    },
    data(){
        return{
            isShowPopup : true
        }
    }
}
</script>